import { defineComponent as p, createElementBlock as i, openBlock as n, mergeProps as f, unref as o, createElementVNode as d, createCommentVNode as u, normalizeClass as a, renderSlot as l, createVNode as c } from "vue";
import r from "../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Icon/icon.js";
import g from "./Spinner.vue2.js";
import { useOUIAProps as P } from "../helpers/ouia.js";
const b = /* @__PURE__ */ p({
  name: "PfNotificationBadge",
  __name: "Icon",
  props: {
    size: {},
    iconSize: {},
    progressIconSize: {},
    status: {},
    inline: { type: Boolean },
    inProgress: { type: Boolean },
    defaultProgressArialabel: { default: "Loading..." },
    shouldMirrorRTL: { type: Boolean },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(t) {
    const s = t, m = P({ id: s.ouiaId, safe: s.ouiaSafe });
    return (e, z) => (n(), i("span", f(o(m), {
      class: [o(r).icon, e.size && o(r).modifiers[e.size], {
        [o(r).modifiers.inline]: e.inline,
        [o(r).modifiers.inProgress]: e.inProgress
      }]
    }), [
      d("span", {
        class: a([o(r).iconContent, e.iconSize && o(r).modifiers[e.iconSize], e.status && o(r).modifiers[e.status], {
          "pf-v6-m-mirror-inline-rtl": e.shouldMirrorRTL
        }])
      }, [
        l(e.$slots, "default")
      ], 2),
      e.inProgress ? (n(), i("span", {
        key: 0,
        class: a([o(r).iconProgress, e.progressIconSize && o(r).modifiers[e.progressIconSize]])
      }, [
        l(e.$slots, "progress-icon", {}, () => [
          c(g, {
            diameter: "1em",
            "aria-label": e.defaultProgressArialabel
          }, null, 8, ["aria-label"])
        ])
      ], 2)) : u("", !0)
    ], 16));
  }
});
export {
  b as default
};
